import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClipboardModule } from 'ngx-clipboard';
import { JsonModalComponent } from './json-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [JsonModalComponent],
  exports: [JsonModalComponent],
  imports: [
    ClipboardModule,
    CommonModule,
    MatDialogModule,MatDividerModule,MatIconModule,MatButtonModule
  ],
})
export class JsonModalComponentModule {}
